import { ref, onMounted, onUnmounted } from 'vue'

const isMobile = ref(false)

export function useIsMobile() {
  const checkMobile = () => {
    isMobile.value = window.innerWidth <= 640
  }

  onMounted(() => {
    checkMobile()
    window.addEventListener('resize', checkMobile)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', checkMobile)
  })

  return isMobile
}
